import { create } from 'zustand';
import publicApi from '../api/publicApi';

const usePublicStore = create((set, get) => ({
    // === STATE ===
    services: [],
    service: null,
    regions: [],
    districts: [],
    serviceTypes: [],
    pagination: null,
    summary: null,
    loading: false,
    detailLoading: false,

    // === FILTERS ===
    filters: {
        region_id: null,
        district_id: null,
        service_type_id: null,
        search: '',
        page: 1,
        per_page: 12,
    },
    setFilter: (key, value) => {
        const newFilters = { ...get().filters, [key]: value, page: 1 };
        set({ filters: newFilters });
    },
    setPage: (page) => {
        set({ filters: { ...get().filters, page } });
    },
    resetFilters: () => {
        set({
            filters: { region_id: null, district_id: null, service_type_id: null, search: '', page: 1, per_page: 12 },
        });
    },

    // === FETCH ALL SERVICES ===
    fetchServices: async () => {
        set({ loading: true });
        try {
            const f = get().filters;
            const params = {};
            if (f.region_id) params.region_id = f.region_id;
            if (f.district_id) params.district_id = f.district_id;
            if (f.service_type_id) params.service_type_id = f.service_type_id;
            if (f.search) params.search = f.search;
            params.page = f.page;
            params.per_page = f.per_page;

            const res = await publicApi.get('/services/all-details', { params });
            const data = res.data?.data || res.data;
            set({
                services: data.services || [],
                pagination: data.pagination || null,
                summary: data.summary || null,
            });
        } catch (err) {
            console.error('fetchServices error:', err);
            set({ services: [] });
        } finally {
            set({ loading: false });
        }
    },

    // === FETCH SINGLE SERVICE ===
    fetchService: async (id) => {
        set({ detailLoading: true, service: null });
        try {
            const res = await publicApi.get(`/services/all-details/${id}`);
            const data = res.data?.data;
            set({ service: data?.service || data || null });
        } catch (err) {
            console.error('fetchService error:', err);
            set({ service: null });
        } finally {
            set({ detailLoading: false });
        }
    },

    // === FETCH REGIONS ===
    fetchRegions: async () => {
        if (get().regions.length) return;
        try {
            const res = await publicApi.get('/regions');
            set({ regions: res.data?.data || res.data || [] });
        } catch (err) {
            console.error('fetchRegions error:', err);
        }
    },

    // === FETCH DISTRICTS ===
    fetchDistricts: async (regionId) => {
        try {
            const res = await publicApi.get(`/regions/${regionId}/districts`);
            set({ districts: res.data?.data || res.data || [] });
        } catch (err) {
            console.error('fetchDistricts error:', err);
        }
    },

    // === FETCH SERVICE TYPES ===
    fetchServiceTypes: async () => {
        if (get().serviceTypes.length) return;
        try {
            const res = await publicApi.get('/service-types');
            set({ serviceTypes: res.data?.data || res.data || [] });
        } catch (err) {
            console.error('fetchServiceTypes error:', err);
        }
    },
}));

export default usePublicStore;
